import { createStyles, makeStyles, Theme, space } from 'ui-components';

const radioNestedIndent = 32;
const radioNestedIndentMobile = 36;

export default makeStyles((theme: Theme) => createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      height: `calc(100vh - ${theme.space.headerMobileHeight}px - 16px)`,
    },
  },
  root: {
    [theme.breakpoints.up('md')]: {
      maxWidth: space.singleColumnMaxWidth,
      margin: '0 auto',
      width: '100%',
      marginTop: 24,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 16,
      flex: 1,
    },
  },
  label: {
    marginBottom: 24,
    paddingLeft: 0,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& .MuiFormControlLabel-root': {
      margin: 0,
      alignItems: 'flex-start',
    },
  },
  radioOptionDetailsBox: {
    width: '100%',
    padding: '4px 0 8px',
    paddingLeft: radioNestedIndent,
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: radioNestedIndentMobile,
    },
  },
  disclaimerFormControl: {
    alignItems: 'flex-start',
    marginBottom: 16,
    marginLeft: 0,
    paddingLeft: 0,
  },
  korpoCodeBox: {
    paddingLeft: 0,
    marginBottom: 8,
  },
  financialInstitutionInput: {
    maxWidth: 308,
    width: '100%',
    paddingTop: 16,
    marginLeft: 0,
    boxSizing: 'border-box',
  },
  korpoCodeInput: {
    maxWidth: 308,
    width: '100%',
    marginTop: 16,
    marginBottom: 16,
  },
  buttonContainer: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
    marginTop: 24,
    borderTop: `1px solid ${theme.color.greys[15]}`,
    paddingTop: 24,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  radioButtonLabel: {},
}), {name: 'TransferIkeIkze'});
